import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { dateUtils } from '../../../../utils/DateUtils';
import { formatNightsLabel, formatPrice } from './reservationUtils';

/**
 * Read-only price breakdown (room line + total), aligned with admin PaymentDetails.PaymentTable.
 */
const ReservationPriceBreakdown = ({ order, roomName }) => {
  const totalPrice = Number(order?.totalPrice);
  if (!order || Number.isNaN(totalPrice)) return null;

  const lengthOfStay = dateUtils.getLengthOfStay(order.checkin, order.checkout);
  const avgPerNight = lengthOfStay > 0 ? totalPrice / lengthOfStay : totalPrice;
  const name = roomName ?? `Pokój nr ${order?.roomId ?? '—'}`;

  return (
    <>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
        Cena
      </Typography>
      <Paper variant="outlined" sx={{ mb: 3, borderRadius: 2, overflow: 'hidden' }}>
        <Table
          size="small"
          sx={{
            '& .MuiTableCell-root': { fontSize: '1rem' },
          }}
        >
          <TableBody>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">
                {name}
                <Typography sx={{ display: 'block' }} variant="caption" color="text.secondary">
                  {formatNightsLabel(lengthOfStay)}
                </Typography>
              </TableCell>
              <TableCell align="right" sx={{ width: '150px' }}>
                {formatPrice(totalPrice)}
                <Typography sx={{ display: 'block' }} variant="caption" color="text.secondary">
                  Średnio za noc: {formatPrice(avgPerNight)}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                borderTop: '1.5px solid',
                borderColor: 'divider',
              }}
            >
              <TableCell component="th" scope="row" sx={{ fontWeight: 700, textAlign: 'right' }}>
                Razem
              </TableCell>
              <TableCell align="right" sx={{ fontWeight: 700, width: '150px' }}>
                {formatPrice(totalPrice)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    </>
  );
};

export default ReservationPriceBreakdown;
